export interface RowContent {
    text: string
    showCheck: boolean;
}
export interface PriceTableContent {
    isSelected?: boolean
    onSelect?: () => void
    category: string
    title?: string
    description?: string
    originalPrice: string
    rows: RowContent[]
    popular?: string
    isPaymentMode?: boolean
    amount?: number
    setAmount?: (_amount: number) => void;
    isAvailable?: boolean
    className?: string
    isActive?: boolean
    isNotPaywall?: boolean
}

export const priceTableData: PriceTableContent[] = [
    {
        category: "Simple Return",
        title: "Simple return for employment income only",
        originalPrice: "49",
        rows: [
            {
                text: "PAYE income for self-employed",
                showCheck: true,
            },
            {
                text: "HMRC-recognised software provider",
                showCheck: true,
            },
            {
                text: "Full calculation of your tax bill for you to review and approve",
                showCheck: true,
            },
            {
                text: "Instant submission to HMRC",
                showCheck: true,
            },
            {
                text: "TaxZap fee can be claimed as an expense next year",
                showCheck: true,
            },
            {
                text: "Expert accountant review & filing done for you",
                showCheck: false,
            },
        ],
        isAvailable: true,
        isNotPaywall: true,
    },
    {
        popular: "MOST POPULAR",
        category: "Self-Employed Return",
        title: "Self-employment businesses, CIS, or rental income",
        originalPrice: "89",
        rows: [
            {
                text: "One income source",
                showCheck: true,
            },
            {
                text: "HMRC-recognised tax return",
                showCheck: true,
            },
            {
                text: "Full calculation of your tax bill for you to review and approve",
                showCheck: true,
            },
            {
                text: "Instant submission to HMRC",
                showCheck: true,
            },
            {
                text: "TaxZap fee can be claimed as an expense next year",
                showCheck: true,
            },
            {
                text: "Expert accountant review & filing done for you",
                showCheck: false,
            },
        ],
        isAvailable: true,
        isNotPaywall: true,

    },
    {
        category: "Standard Return",
        title: "For multiple income sources",
        originalPrice: "159",
        rows: [
            {
                text: "Multiple income sources",
                showCheck: true,
            },
            {
                text: "HMRC-recognised tax return",
                showCheck: true,
            },
            {
                text: "Full calculation of your tax bill for you to review and approve",
                showCheck: true,
            },
            {
                text: "Instant submission to HMRC",
                showCheck: true,
            },
            {
                text: "TaxZap fee can be claimed as an expense next year",
                showCheck: true,
            },
            {
                text: "Expert accountant review & filing done for you",
                showCheck: false,
            },
        ],
        isAvailable: true,
        isNotPaywall: true,

    },
    {
        category: "Reviewed Return",
        title: "Standard return plus an accountant's review",
        originalPrice: "220",
        rows: [
            {
                text: "Single or multiple income",
                showCheck: true,
            },
            {
                text: "HMRC-recognised tax return",
                showCheck: true,
            },
            {
                text: "Full calculation of your tax bill for you to review and approve",
                showCheck: true,
            },
            {
                text: "Instant submission to HMRC",
                showCheck: true,
            },
            {
                text: "TaxZap fee can be claimed as an expense next year",
                showCheck: true,
            },
            {
                text: "Expert accountant review & filing done for you",
                showCheck: true,
            },
        ],
        isAvailable: true,
        isNotPaywall: true,
    },
];
